module.exports = __webpack_public_path__ + "static/mulher-sentada-puff-azul-89c84770cd9009ddcad9a49d29b32c34.png";